module.exports = __webpack_public_path__ + "img/371bf77.webp";